function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var _ref = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#session-pulse-checks-reporting_svg__clip0_1_1748)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M52.699 29.49H13.95l-7.203 8.068V29.49H.062V.156H52.7v29.335z",
  fill: "#E5E5E5"
}), /*#__PURE__*/React.createElement("path", {
  d: "M44.068 8.773H8.694v1.59h35.374v-1.59zM44.068 14.029H8.694v1.589h35.374v-1.589zM44.068 19.285H8.694v1.589h35.374v-1.59z",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  d: "M6.855 42.495c.735 0 1.33-.599 1.33-1.337 0-.74-.595-1.338-1.33-1.338-.735 0-1.33.599-1.33 1.338 0 .738.595 1.337 1.33 1.337z",
  fill: "#E6E6E6"
}), /*#__PURE__*/React.createElement("path", {
  d: "M92.975 80.45h-1.49l-.71-5.782h2.2v5.781z",
  fill: "#9F616A"
}), /*#__PURE__*/React.createElement("path", {
  d: "M93.356 81.902H88.55v-.061c0-.5.197-.978.547-1.33.351-.353.827-.551 1.323-.551h2.936v1.942z",
  fill: "#2F2E41"
}), /*#__PURE__*/React.createElement("path", {
  d: "M78.448 80.33l-1.413-.476 1.155-5.707 2.086.703-1.828 5.48z",
  fill: "#9F616A"
}), /*#__PURE__*/React.createElement("path", {
  d: "M78.35 81.83l-4.558-1.537.02-.058c.157-.473.496-.863.94-1.086a1.862 1.862 0 011.428-.1l2.783.939-.614 1.841zM80.285 50.574l-3.227 27.454 3.166.269s4.98-26.993 6.514-23.795c1.536 3.197 3.417 23.196 3.417 23.196h3.142s.805-31.203-2.484-32.747l-10.528 5.623z",
  fill: "#2F2E41"
}), /*#__PURE__*/React.createElement("path", {
  d: "M88.652 27.956a3.196 3.196 0 00-2.58-3.704 3.182 3.182 0 00-3.684 2.594 3.196 3.196 0 002.58 3.704 3.182 3.182 0 003.684-2.594z",
  fill: "#9F616A"
}), /*#__PURE__*/React.createElement("path", {
  d: "M83.63 31.775l4.057.331s3.235.055 4.551.937c1.316.882-1.261 6.34-1.261 6.34s-.67 2.164-.164 3.142c1.64 3.175 1.397 5.62 1.397 5.62s-3.371.775-9.183 2.319c0 0-3.619 1.433-3.51.662.11-.772 1.207-9.593 1.207-9.593v-9.151l2.906-.607z",
  fill: "#3F3D56"
}), /*#__PURE__*/React.createElement("path", {
  d: "M90.728 27.055c-.162-.91-.526-2.203-1.336-3.182h.076c.279-.008.595-.096.71-.35a.613.613 0 00-.11-.61 1.788 1.788 0 00-.507-.398c.195.12.471.23.627.063a.341.341 0 00.038-.364.9.9 0 00-.243-.295 5.995 5.995 0 00-1.072-.76c-.297-.166-.688-.298-.955-.087-.272.215-.228.634-.158.974a1.111 1.111 0 00-.5-.151.382.382 0 00-.382.296.397.397 0 00.177.344c-1.049-.173-2.389.024-4.101.82 0 0-1.661.557-1.745 2.755-.009.352.03.703.115 1.044.094.399.426 2.353.027 3.143l2 .717.023-1.205c-1.554-2.256-.787-3.084-.181-4.44a.014.014 0 01.005-.007.014.014 0 01.02.004c.112.194.54.855 2.016.855l-.57-.573s2.508 1.032 3.42 1.032c0 0 .683.458 0 1.146-.684.687-2.181 1.7-1.383 2.96.798 1.261.729 1.709.729 1.709l1.824-1.032s1.114-2.216 1.311-2.869a3.309 3.309 0 00.125-1.54z",
  fill: "#2F2E41"
}), /*#__PURE__*/React.createElement("path", {
  d: "M68.812 51.902h36.284v20.222h-4.609v5.56l-4.965-5.56h-26.71V51.902z",
  fill: "#0E72ED"
}), /*#__PURE__*/React.createElement("path", {
  d: "M99.146 57.842H74.761v1.096h24.385v-1.096zM99.146 61.465H74.761v1.096h24.385v-1.096zM99.146 65.088H74.761v1.096h24.385v-1.096z",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  d: "M92.636 38.946l-2.129.52-.016 4.33-2.393 8.307a1.345 1.345 0 00-.485 1.306 1.349 1.349 0 00.927 1.036 1.33 1.33 0 001.342-.346 1.346 1.346 0 00.317-1.356l2.862-8.6-.425-5.197zM78.471 38.855l2.553.733.016 4.33 2.394 8.308a1.344 1.344 0 01.484 1.305 1.347 1.347 0 01-.926 1.036 1.33 1.33 0 01-1.342-.345 1.347 1.347 0 01-.317-1.357l-2.862-8.599v-5.411z",
  fill: "#9F616A"
}), /*#__PURE__*/React.createElement("path", {
  d: "M89.442 32.602l.527-.173c.297-.097.619-.074.899.063 0 0 1.535.11 1.754 1.213.22 1.102.753 10.74.753 10.74l-3.252-1.04-.681-10.803zM82.04 32.602l-.934-.047-.295-.149s-1.732.196-1.951 1.299c-.22 1.102-.858 11.037-.858 11.037l3.252-.892.786-11.248z",
  fill: "#3F3D56"
}), /*#__PURE__*/React.createElement("path", {
  d: "M28.409 71.664l1.541-1.352a26.014 26.014 0 00-.36-2.895l-.85.362.789-.692a23.363 23.363 0 00-.452-1.95s-3.11 2.777-4.85 6.164l.763 2.525-1.166-1.67c-.174.403-.322.817-.443 1.239-1.214 4.256-.815 8.105.89 8.596 1.706.492 4.072-2.56 5.285-6.816a13.86 13.86 0 00.428-4.18l-1.575.67z",
  fill: "#F1F1F1"
}), /*#__PURE__*/React.createElement("path", {
  d: "M32.49 74.974l2.015-.357c.443-.865.837-1.755 1.18-2.665l-.914-.133 1.031-.182c.413-1.13.616-1.904.616-1.904s-4.09.76-7.321 2.756l-.645 2.558-.14-2.035a10.42 10.42 0 00-1.016.83c-3.226 3.012-4.864 6.514-3.656 7.821 1.207 1.308 4.801-.075 8.028-3.088a13.78 13.78 0 002.515-3.356l-1.692-.245z",
  fill: "#F1F1F1"
}), /*#__PURE__*/React.createElement("path", {
  d: "M109.915 82.045H18.568a.148.148 0 01-.147-.149.15.15 0 01.147-.148h91.347a.149.149 0 010 .297z",
  fill: "#CBCBCB"
}));
var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "session-pulse-checks-reporting_svg__clip0_1_1748"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  transform: "translate(.063 .156)",
  d: "M0 0h110v82H0z"
})));
function SvgSessionPulseChecksReporting(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 111 83",
    fill: "none"
  }, props), _ref, _ref2);
}
export default __webpack_public_path__ + "fonts/session-pulse-checks-reporting-9444faca37676833646c1227ebcd8014.svg";
export { SvgSessionPulseChecksReporting as ReactComponent };